<div
  class="p-3 border border-ui-gray-light rounded-md bg-white shadow-sm"
  [ngClass]="{'flex items-start': !isMobile}"
>
  @if (showToggle()) {
    <div
      class="mr-4"
      [showForClientAdmin]="true"
      avsRestrictedEl
    >
      <mat-slide-toggle
        class="main-toggle"
        (change)="onToggle($event.checked)"
        [checked]="checked()"
        [disabled]="incidentRule().status === eIncidentRuleStatus.ADMIN_DISABLED"
      />
    </div>
  }

  <div class="flex-1">
    @if (incidentRule().name) {
      <div class="mb-3 font-bold text-sm">{{ incidentRule().name }}</div>
    }
    <div class="flex items-center font-medium gap-2 text-sm mt-0.5">
      <span class="font-semibold text-ui-gray-750 mr-3">IF</span>
      <span class="text-ui-dark mr-3">{{ incidentRule().code }}</span>
      @if (measurementUnit(); as unit) {
        <span
          class="text-ui-gray-100 mr-3"
          [matTooltip]="unit.display"
        >({{ unit.displayShort }})</span>
      }
      <span class="font-semibold text-ui-gray-750 mr-3">{{ incidentRule().operator }}</span>
      <span class="text-ui-dark">{{ incidentRule().conditionValue }}</span>
      @if (durationMinutesLabel()) {
        <span class="text-ui-gray-100 ml-1">FOR</span>
        <span class="text-ui-dark ml-1">{{ durationMinutesLabel() }}</span>
      } @else if (durationLabel()) {
        <span class="text-ui-gray-100 ml-1">{{ durationLabel() }}</span>
      }
    </div>

    <div class="mt-3 flex items-center">
      <div class="p-1 px-2 mr-2 border border-ui-gray-lighter rounded-md text-xs">
        <avs-incident-severity-icon
          [severity]="incidentRule().severity"
          [showLabel]="true"
        />
      </div>
      @if (incidentRule().system) {
        <div class="rule-status-badge">
          System
        </div>
      }
      @if (incidentRule().status === eIncidentRuleStatus.ADMIN_DISABLED) {
        <div class="rule-status-badge">
          Disabled by Super Admin
        </div>
      }
      @if ('workflow-schedule' | avsFeatureFlag) {
        <avs-schedule-info
          [scheduleConfig]="incidentRule().scheduleConfig"
          [scheduleEnabled]="!!incidentRule().scheduleEnabled"
        />
      }
    </div>
  </div>

  @if (editable()) {
    <div
      class="flex items-center gap-2"
      [showForClientAdmin]="true"
      avsRestrictedEl
    >
      @if (!incidentRule().system && ('share-incident-rule' | avsFeatureFlag)) {
        <button
          type="button"
          class="icon-btn"
          (click)="onShare()"
          matTooltip="Share"
          matTooltipPosition="above"
        >
          <mat-icon class="action-icon">share</mat-icon>
        </button>
      }
      <button
        type="button"
        class="icon-btn"
        (click)="onEdit()"
        matTooltip="Edit"
        matTooltipPosition="above"
      >
        <i class="icon-edit action-icon"></i>
      </button>
      @if (!incidentRule().system) {
        <button
          type="button"
          class="icon-btn -ml-0.5"
          (click)="onDelete()"
          matTooltip="Delete"
          matTooltipPosition="above"
        >
          <i class="icon-remove action-icon text-4xl"></i>
        </button>
      }

    </div>
  }

</div>
